export default [ 'webkit', 'moz', 'ms', 'o' ];
